import getFeeAmount from './get-fee-amount.js'
import getSenderNonceKey from './get-sender-nonce-key.js'

export default function checkPendingTransactions({
  pendingTransactionsGroupedByAddressAndNonce = {},
  pendingTransactionsToCheck = {},
  txlist,
  ourWalletAddress,
  asset,
}) {
  for (const tx of txlist) {
    // eslint-disable-next-line @exodus/mutable/no-param-reassign-prop-only
    delete pendingTransactionsToCheck[tx.txId || tx.hash] // Found this transaction, do not mark it as dropped

    // check if this TX replaces another pending TX
    const replacedTx =
      pendingTransactionsGroupedByAddressAndNonce[getSenderNonceKey(tx, ourWalletAddress)]
    if (replacedTx && tx.hash !== replacedTx.tx.txId) {
      // if a pending TX with lower fees comes from the server, don't add it
      if (
        replacedTx.tx.sent &&
        replacedTx.tx.feeAmount.gt(getFeeAmount(asset, tx)) &&
        tx.confirmations === 0
      ) {
        continue
      }

      replacedTx.replaced = true
    }
  }

  return { pendingTransactionsGroupedByAddressAndNonce, pendingTransactionsToCheck }
}
